// Sends real operational events into BSTM ELOS (the ecosystem's learning/
// intelligence engine). This file runs entirely in the browser bundle, so
// unlike server-side integrations (CabLink, Business Health Audit) there is
// no secret key here — anything shipped in client JS is public anyway, so
// this call is intentionally unauthenticated. ELOS's write endpoints accept
// unauthenticated requests by design for exactly this case.
//
// Fire-and-forget: a slow or unreachable ELOS must never block or fail a
// real receipt/incident submission for the person using the app.

const ELOS_EVENTS_URL = 'https://bstm-elos.vercel.app/api/events';

export async function sendElosEvent(eventType, entityId, data) {
  try {
    await fetch(ELOS_EVENTS_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        event_type: eventType,
        source: 'flowledger',
        entity_type: 'TRANSACTION',
        entity_id: entityId,
        data,
      }),
    });
  } catch (error) {
    console.warn('ELOS event delivery failed (non-blocking):', error.message);
  }
}
